// extracted by mini-css-extract-plugin
export default {"chart":"BigColumn_chart__45+ov","title":"BigColumn_title__92nEV"};